import { ListGroupsAudit } from 'domain/usecases/audit/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteListGroupsAudit implements ListGroupsAudit {
  private readonly url: string;

  private readonly httpClient: HttpClient<ListGroupsAudit.Model>;

  constructor(url: string, httClient: HttpClient<ListGroupsAudit.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  listGroups = async (
    params: ListGroupsAudit.Params,
  ): Promise<ListGroupsAudit.Model> => {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}`,
      body: params.body,
      method: 'post',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
